import * as React from 'react';
import { observer } from 'mobx-react';
import { IDispersionEllipse } from 'Data';
import { IReportDataService, ReportDataServiceHelper } from 'Services';
import { IDispersionElipseProps } from './IDispersionElipseProps';

export interface DispersionElipseState {
  dispersionElipse?: IDispersionEllipse;
}

@observer
export class DispersionElipse extends React.Component<
  IDispersionElipseProps,
  DispersionElipseState
> {
  private readonly reportDataService: IReportDataService;
  elipseDownloaded = false;

  private fetchData(nextProps?: IDispersionElipseProps): void {
    const props = nextProps || this.props;

    if (!props || !props.dispersionCoordinates || props.dispersionCoordinates.length < 2) {
      this.elipseDownloaded = false;
      return;
    }

    this.reportDataService
      .getDispersionEllipse(props.dispersionCoordinates, props.elipseColor)
      .then(
        (response: IDispersionEllipse) => {
          if (
            response &&
            response?.CtrY &&
            response?.CtrY &&
            response?.CtrX &&
            response?.A &&
            response?.B
          ) {
            this.elipseDownloaded = true;
            this.setState({ dispersionElipse: response });
          }
        },
        reason => {
          console.log('DispersionEllipse error');
          console.log(reason);
        }
      );
  }

  constructor(props: IDispersionElipseProps) {
    super(props, undefined);
    this.reportDataService = this.props.reportDataService;
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUpdate(nextProps: IDispersionElipseProps) {
    if (
      !ReportDataServiceHelper.compareDispersionCoordinates(
        this.props.dispersionCoordinates,
        nextProps.dispersionCoordinates
      )
    ) {
      this.fetchData(nextProps);
    }
  }

  render() {
    return (
      this.elipseDownloaded &&
      this.state.dispersionElipse && (
        <ellipse
          cx={this.props.xAxisScale(this.state.dispersionElipse.CtrX)}
          cy={this.props.yAxisScale(this.state.dispersionElipse.CtrY)}
          rx={this.props.xAxisScaleForEllipsis(this.state.dispersionElipse.A)}
          ry={this.props.yAxisScaleForEllipsis(this.state.dispersionElipse.B)}
          fill="transparent"
          strokeWidth="2"
          transform={
            'rotate(' +
            this.state.dispersionElipse.Angle +
            ', ' +
            this.props.xAxisScale(this.state.dispersionElipse.CtrX) +
            ', ' +
            this.props.yAxisScale(this.state.dispersionElipse.CtrY) +
            ')'
          }
          stroke={this.props.elipseColor}
        ></ellipse>
      )
    );
  }
}
